class LocalStorage {
  private storage: Storage
  private isSupported: boolean = true

  constructor() {
    try {
      this.storage = window.localStorage
      this.isSupported = this.checkSupport()
    } catch (e) {
      this.isSupported = false
    }
  }

  public removeItem (key: string) {
    this.storage.removeItem(key)
  }

  public setItem (key: string, value: any) {
    if (this.isSupported) {
      this.storage.setItem(key, this.serialize(value))
    }
  }

  public getItem (key: string): any | null {
    let value: string | null = null

    if (this.isSupported && this.hasItem(key)) {
      value = this.storage.getItem(key)
    }

    return this.deserialize(value)
  }

  public hasItem (key: string): boolean {
    if (this.isSupported) {
      return this.storage.getItem(key) !== null
    }

    return false
  }

  private checkSupport (): boolean {
    if (this.storage === null) {
      return false
    }

    let support = true
    try {
      const testKey = '__storage__'
      this.storage.setItem(testKey, testKey)
      if (this.storage.getItem(testKey) !== testKey) {
        support = false
      }
      this.storage.removeItem(testKey)
    } catch (e) {
      support = false
    }

    return support
  }

  private serialize (obj: any): string {
    return JSON.stringify(obj)
  }

  private deserialize (strVal: string | null, defaultVal: any = null): any | null {
    if (!strVal) {
      return defaultVal
    }

    // It is possible that a raw string value has been previously stored
    // in a storage without using this class, meaning it will be a raw
    // string value instead of a JSON serialized string. By defaulting
    // to the raw string value in case of a JSON parse error, we allow
    // for past stored values to be forwards-compatible with this class
    let val = ''
    try {
      val = JSON.parse(strVal)
    } catch (e) {
      val = strVal
    }

    return (val !== undefined ? val : defaultVal)
  }
}

export default new LocalStorage()
